<svg-icon class="svg" src="assets/logos/VVR_b-rood.svg"></svg-icon>
<div *ngIf="icon" [style.background-color]="iconBackground" class="svg">
    <i class="{{icon}}"></i>
</div>
<div [style.background-image]="thumb | safeBgUrl" class="thumb"></div>
<div #imagediv [style.background-image]="image | safeBgUrl" class="image"></div>
<img (load)="imagediv.classList.add('loaded')" [src]="image | safeSrc"/>

